import { Dropdown } from '@missionlabs/smartagent-app-components';
import { SADropdownOption } from '@missionlabs/smartagent-app-components/dist/Dropdown';
import useSettings from 'hooks/redux/useSettings';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getRoutingProfiles } from 'store/settings/settings.actions';
import { IGroup } from 'store/settings/settings.state';

interface IRoutingProfileData {
    data: string;
    label: string;
}
interface Props {
    onChange: (option: SADropdownOption) => void;
    onDeleteTag: (_: SADropdownOption<IRoutingProfileData>, i: number) => void;
    filter: boolean;
    required: boolean;
    showError: boolean;
    title: string;
    label: string;
    routingProfileIds: string[];
}

const constructSelectedProfiles = (
    routingProfilesIDs: string[],
    routingProfiles: IGroup[]
) => {
    return routingProfilesIDs.map((id: string) => {
        const rp = routingProfiles.find(({ Id }) => id === Id);

        return {
            label: rp?.Name ?? 'Unknown routing profile',
            data: rp?.Id,
        };
    });
};

const RoutingProfileDropdownMultiple: React.FC<Props> = ({
    onChange,
    onDeleteTag,
    title,
    required,
    showError,
    label,
    routingProfileIds,
    filter,
}) => {
    const dispatch = useDispatch();

    const { routingProfiles } = useSettings();

    useEffect(() => {
        if (!routingProfiles) dispatch(getRoutingProfiles());
    }, [routingProfiles, dispatch]);

    const options = useMemo(() => {
        if (routingProfiles) {
            return routingProfiles
                .map((rp) => ({
                    label: rp.Name,
                    data: rp.Id,
                }))
                .sort((a, b) =>
                    a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1
                );
        }

        return [
            {
                label: `Loading routing profiles`,
                data: undefined,
            },
        ];
    }, [routingProfiles]);

    const renderValue = useCallback(() => {
        if (routingProfiles) {
            const selectedProfiles = constructSelectedProfiles(
                routingProfileIds,
                routingProfiles
            );

            return selectedProfiles;
        }

        return 'Loading...';
    }, [routingProfiles, routingProfileIds]);

    return (
        <Dropdown
            title={title}
            required={required}
            showError={showError}
            options={options}
            label={label}
            filter={filter}
            onDeleteTag={(_, i) => onDeleteTag(_, i)}
            onChange={(option) => onChange(option)}
            value={renderValue()}
        />
    );
};

export default RoutingProfileDropdownMultiple;
